var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"primary cur",on:{"click":_vm.displayChildItem}},[_vm._v(_vm._s(_vm.ctrlFoldContent[("" + (_vm.$route.fullPath))] ? '收起' : '展开'))])}
var staticRenderFns = []

export { render, staticRenderFns }